import { Injectable } from '@angular/core';
import { SupabaseBaseHttpService, TableRowModel } from '@examdojo/supabase';
import { from } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActivityHttpService extends SupabaseBaseHttpService<'activities', 'learning'> {
  readonly schema = 'learning';
  readonly tableName = 'activities';

  override readonly id_field: keyof TableRowModel<'activities', 'learning'> = 'user_id';

  override fetch(itemId: string) {
    return from(
      this.supabase.client
        .schema(this.schema)
        .from(this.tableName)
        .select()
        .eq(this.id_field, itemId)
        .maybeSingle()
        .throwOnError()
        .then((response) => response.data!),
    );
  }
}
